import cardCode from "./cardCode";

export default {
    ...cardCode
}
